import { SyncState } from '@/types/graphql';
import { makeDarker, makeTranslucent } from '@/utils/colors';
import { blue, green, grey, red } from '@mui/material/colors';

// Single source of truth for sync-status colors
// So far,shared by the sync-status popover and the Outlook integration card.
// One base accent per state.
export const SYNC_STATE_COLOR: Record<SyncState, string> = {
    [SyncState.SUCCEEDING]: green[800],
    [SyncState.FAILING]: red[700],
    [SyncState.PENDING]: blue[700],
    [SyncState.NEVER_ATTEMPTED]: grey[600],
};

export type SyncStatusColorConfig = {
    accentColor: string;
    backgroundColor: string;
    iconBackgroundColor: string;
    borderColor: string;
    headerColor: string;
};

// Derive the full color set (accent + translucent background/icon/border +
// darkened header) from a base accent.
export const makeSyncStatusColorConfig = (base: string): SyncStatusColorConfig => ({
    accentColor: base,
    backgroundColor: makeTranslucent(base, 0.1),
    iconBackgroundColor: makeTranslucent(base, 0.2),
    borderColor: makeTranslucent(base, 0.35),
    headerColor: makeDarker(base, 40),
});
